import styled from 'styled-components';
import { Icon as SonarIcon } from '@appcues/sonar';

export const ChecksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  margin-top: var(--spacing-small);
`;

const PanelContainer = styled.details`
  border: var(--border-width-x-small) solid var(--border-default);
  border-radius: var(--border-radius-small);
  font-size: var(--regular);
  transition: opacity 200ms ease;
  opacity: ${({ dragging }) => (dragging ? 0.5 : 1)};
  background-color: ${({ droppable }) =>
    droppable ? 'var(--background-hover)' : 'var(--background-app)'};
`;

const PanelSummary = styled.summary`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-small);
  padding: var(--spacing-small) var(--spacing-regular);
  font-weight: var(--bold);
  cursor: pointer;
  list-style: none;
`;

const PanelContent = styled.div`
  padding: var(--spacing-regular);
  background-color: var(--foreground-inverse);
  color: var(--foreground-secondary);
  border-radius: 0 0 var(--border-radius-small) var(--border-radius-small);
`;

export const Panel = {
  Container: PanelContainer,
  Summary: PanelSummary,
  Content: PanelContent,
};

export const Title = styled.span`
  flex: 1;
  word-break: break-word;
`;

export const RotatingIcon = styled(SonarIcon)`
  transition: transform 200ms cubic-bezier(0.87, 0, 0.13, 1);
  [open] & {
    transform: rotate(-180deg);
  }
`;

export const DragHandle = styled.div`
  cursor: grab;
  color: var(--foreground-tertiary);
  transition: color 200ms ease;

  &:hover {
    color: var(--foreground-secondary);
  }

  &:active {
    cursor: grabbing;
  }

  ${({ dragging }) =>
    dragging &&
    `
    cursor: grabbing;
  `}
`;
